/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Week_AgendaInputs */

const en_portal_week_agenda = /** @type {(inputs: Portal_Week_AgendaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This week`)
};

const pl_portal_week_agenda = /** @type {(inputs: Portal_Week_AgendaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ten tydzień`)
};

/**
* | output |
* | --- |
* | "This week" |
*
* @param {Portal_Week_AgendaInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_week_agenda = /** @type {((inputs?: Portal_Week_AgendaInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Week_AgendaInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_week_agenda(inputs)
	return en_portal_week_agenda(inputs)
});